import { Box, Stack, TextField, Button, Tooltip, Typography, FormControlLabel, Checkbox } from '@mui/material'
import { useEffect, useState } from 'react'
import { Colors } from '../../../../Styles/Colors'
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const GlobalRoleMaster = () => {
    const history = useHistory();
    const [state, setState] = useState({
        therapy_master_data: [],
        is_loader: false,
        page: 0,
        pageSize: 10,
        //toast msg state
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: "",
    });

    useEffect(() => {
        getRoleMasterList()
    }, [])

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ""
        })
    }

    const getRoleMasterList = () => {
        try {
            updateState({ is_loader: true })
            RestAPIService.getAll(Serviceurls.GLB_ROLE_MASTER)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const Data = response.data.data || []
                        updateState({
                            therapy_master_data: Data?.map((element, index) => ({ ...element, sno: index + 1 })),
                            is_loader: false
                        })
                    }
                }).catch(e => {
                    updateState({ is_loader: false })
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            updateState({ is_loader: false })
            errorMessage(e.message)
        }
    }

    const tableView = () => {

        const gridToolBar = () => {
            return (
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} height={'3vw'} p={2}>
                    <GridToolbarQuickFilter
                        sx={{ flexWrap: 'nowrap' }}
                        isInactive={true}
                    />
                    <Button style={{marginTop:"0.75vw"}} size='small' variant='contained' onClick={() => { history.push("/Settings/UserAccess/UserSettings/GlobalRoleMaster/AddRole") }}>
                        {"Add"}
                    </Button>
                </Box>
            )
        }

        const columns = [
            {
                field: 'role_code', headerName: 'Role Code', flex: 0.2,
                renderCell: ({ row }) => (<Box component={'div'}>{row?.role_code ? row?.role_code : '-'}</Box>)

            },
            {
                field: 'role_name', headerName: 'Role Name', flex: 0.5,
                renderCell: ({ row }) => (row.role_name ? row.role_name?.length > 100 ?
                    <Tooltip placement="top" title={row.role_name}><Typography fontSize={'0.9vw'}>{row.role_name?.slice(0, 100) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{row.role_name}</Typography> : '-')

            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: ({ row }) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw"
                                disable={state?.selected_ids?.length > 0}
                                onClick={() =>
                                    history.push("/Settings/UserAccess/UserSettings/GlobalRoleMaster/AddRole",
                                        {
                                            role_name: row.role_name || "",
                                            role_code: row.role_code || null,
                                            edit_id: row.id,
                                        })
                                } />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '74vh', marginTop: '.5vw' }}>
                <DataGrid
                    rows={state.therapy_master_data}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={state.page}
                    pageSize={state.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { updateState({ page: newPage }) }}
                    onPageSizeChange={(newPageSize) => { updateState({ pageSize: newPageSize }) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={state.is_loader}
                />
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '61vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {state.isErrorMsg && <ToastMsg severity={"error"} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={"success"} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
        </Box>
    )
}
export default GlobalRoleMaster